import { getOperatorOptions } from '../logicHelpers'
import { validateDomain, validateURL } from '../../services/validationHelpers'

const referrerSource = () => {
  return {
    types: [
      { label: 'No one (direct traffic)', value: 'direct' },
      { label: 'Any site (not direct traffic)', value: 'referral' },
      { label: 'Specific domain', value: 'domain' },
      { label: 'Specific URL', value: 'custom' }
    ],
    inputs: [
      {
        $formkit: 'text',
        key: 'domain-input',
        name: 'domain',
        placeholder: 'example.com',
        can: (condition: { $source: string; $type: string }) =>
          condition.$source === 'referrer' && condition.$type === 'domain',
        validate: validateDomain
      },
      {
        $formkit: 'select',
        key: 'operator-select',
        name: 'operator',
        options: getOperatorOptions(),
        can: (condition: { $source: string; $type: string }) =>
          condition.$source === 'referrer' && condition.$type === 'custom'
      },
      {
        $formkit: 'text',
        key: 'custom-referrer-input',
        name: 'custom_referrer',
        placeholder: 'https://example.com/blog/some-article',
        size: 'large',
        can: (condition: { $source: string; $type: string }) =>
          condition.$source === 'referrer' && condition.$type === 'custom',
        validate: (value: string, { operator }: { operator?: string }) => {
          // Only validate URL format for exact matching operators
          if (operator === 'equals' || operator === 'does not equal' || operator === 'starts with') {
            return validateURL(value)
          }
          return null
        }
      }
    ]
  }
}

export default referrerSource
